import styles from './slide.module.css';
import classNames from 'classnames';
import ResilientImage from 'components/shared/media/ResilientImage';

const Slide = (item) => {
    if(item?.url) {
        return (

            <ResilientImage
                className={styles.image}
                src={item?.url}
                backupSrc={item?.backup_url}
                alt=''
                preferenceKey={`card-slide:${item?.id || item?.url || 'url'}`}
            />

        );
    }
  return (
    <div className={classNames('image-gallery-image', styles.wrapper)}>
      {item?.original && (
        <ResilientImage
          className={styles.image}
          src={item?.original}
          backupSrc={item?.backup_original || item?.backup_url}
          alt=''
          preferenceKey={`card-slide:${item?.id || item?.original || 'original'}`}
        />
      )}
    </div>
  );
};

export default Slide;
